<!--<div class="page-container" style="min-height:188.38330078125px">
  <div class="page-content">-->
<div id="requestModal" class="modal fade" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-xl modal-lg modal-md">
    <div class="modal-content">
      <div class="modal-header bg-primary-400">
        <button type="button" class="close" (click)="FinishRecipientSettings()">&times;</button>
        <h6 class="modal-title" translate>Recipient Settings</h6>
      </div>
      <div class="modal-body">
        <div style="text-align: center; margin-bottom: 10px; margin-bottom: 10px; font-size: 15px;" [hidden]="calculateUnaminity()"><label style="color:red">{{ translate.instant("If you change anything here, shared signing options will be set to default.") }}</label></div>
        <div class="panel panel-flat shadow" style="border: none">
          <div class="panel-body">
           <!-- <h4>Move items between multi list sortable containers</h4>-->
            <div *ngIf="userPlan?.addRecipient == 'Y'" class="row">
              <div class="col-sm-12">
                <!--Drag Containers <input type="checkbox" [(ngModel)]="dragOperation"/>-->
                <div cdkDropList [cdkDropListData]="containers" (cdkDropListDropped)="dropContainer($event)">
                  <div class="col-sm-12"
                       *ngFor="let container of containers; let i = index"
                       cdkDrag>

                    <div class="panel panel-warning">
                      <div class="panel-body">
                        <table class="table table-md table-sm table-xs table-condensed table-borderless text-center">
                          <tbody>
                          <tr>
                            <td class="col-md-1 col-sm-1 col-xs-1" style="border-right: solid 1px lightgrey; padding-right: 10px">
                              <h1><strong>{{ i + 1 }}</strong></h1>
                            </td>
                            <td class="col-md-11 col-sm-11 col-xs-11">
                              <button type="button" class="btn btn-primary pull-right"
                                      style="margin-bottom: 10px"
                                      [ngClass]="{ 'disabled': userPlan?.maxRecipients <= job.recipients.length }"
                                      (click)="showAddressBookModal('PARALLEL', i + 1)">
                                <i class="icon-address-book"></i>
                              </button>
                              <button type="button" class="btn btn-primary pull-right-xs"
                                      style="margin-right: 5px; padding-right: 5px"
                                      [ngClass]="{ 'disabled': userPlan?.maxRecipients <= job.recipients.length }"
                                      (click)="showAddModal(); selectedContainer = i + 1">
                                <i class="icon-plus3"></i><span translate>Add Parallel Recipient</span>
                              </button>

                              <table class="table table-md table-sm table-condensed table-borderless text-left">
                                <tbody
                                  cdkDropList
                                  [id]="'recipient-list-' + i"
                                  [cdkDropListData]="container.widgets"
                                  [cdkDropListConnectedTo]="getRecipientListIds()"
                                  (cdkDropListDropped)="dropWidget($event, i)">
                                <tr *ngFor="let recipient of container.widgets; let x = index"
                                    cdkDrag>
                                  <td class="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-center" style="padding: 0px">
                                    <i class="icon-menu7" cdkDragHandle></i>
                                  </td>
                                  <td class="col-lg-9 col-md-9 col-sm-9 col-xs-9 recipient-cell">
                                    <div class="recipient-line">
                                      <span class="recipient-name">{{ recipient?.name }}</span>
                                      <span class="recipient-email"><i class="icon-mail5"></i>{{ recipient?.email }}</span>
                                    </div>
                                    <div class="recipient-meta">
                                      <app-method-badge [method]="recipient?.signMethod"></app-method-badge>
                                      <app-chip-group [caption]="translate.instant('LIST_ACCESS_CAPTION')">
                                        <app-chip [label]="translate.instant('ACCESS_EMAIL_TITLE')" icon="ph-bold ph-envelope-simple"></app-chip>
                                      </app-chip-group>
                                      <app-chip-group *ngIf="recipient?.signMethod === 'qes' && recipient?.citizenId" [caption]="translate.instant('LIST_IDENTITY_CAPTION')">
                                        <app-chip [label]="translate.instant('LIST_CHIP_TCK')" [value]="recipient.citizenId"></app-chip>
                                      </app-chip-group>
                                      <app-chip-group *ngIf="recipient?.signMethod === 'bio' && recipient?.smsRequired" [caption]="translate.instant('LIST_IDENTITY_CAPTION')">
                                        <app-chip [label]="translate.instant('LIST_CHIP_SMS')" [value]="'(+' + recipient.smsCountryCode + ') ' + recipient.smsRequired"></app-chip>
                                      </app-chip-group>
                                      <app-chip-group *ngIf="!recipient?.signMethod && (recipient?.citizenId || recipient?.smsRequired)" [caption]="translate.instant('LIST_IDENTITY_CAPTION')">
                                        <app-chip *ngIf="recipient?.citizenId" [label]="translate.instant('LIST_CHIP_TCK')" [value]="recipient.citizenId"></app-chip>
                                        <app-chip *ngIf="recipient?.smsRequired" [label]="translate.instant('LIST_CHIP_SMS')" [value]="'(+' + recipient.smsCountryCode + ') ' + recipient.smsRequired"></app-chip>
                                      </app-chip-group>
                                    </div>
                                  </td>
                                  <td class="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-right">
                                    <button class="btn btn-default btn-xs" type="button" (click)="showUpdateModal(recipient)">
                                      <i class="icon-pencil6"></i>
                                    </button>
                                  </td>
                                  <td class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                                    <button type="button" class="btn btn-default btn-xs"
                                            [ngClass]="{ 'disabled': recipient.email == job.user.email && userPlan.removeOwnRecipient == 'N' }"
                                            (click)="showRemoveAlert(recipient)">
                                      <i class="icon-trash"></i>
                                    </button>
                                  </td>
                                </tr>
                                </tbody>
                              </table>

                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
          </div>
          <div *ngIf="userPlan?.signSerial == 'Y'" class="row text-center button-container">
            <!--[ngClass]="{ 'disabled': userPlan?.signSerial == 'N' }"-->
            <button type="button" class="btn btn btn-primary btn-xlg" (click)="showAddModal();selectedContainer=maxOrderNo+1"><i class="icon-plus3"></i><span translate>Add Serial Recipient</span></button>
            <button type="button" class="btn btn-primary btn-xlg" (click)="showAddressBookModal('SERIAL')"><i class="icon-address-book"></i></button>
          </div>
        </div>
      </div>
      <div class="panel panel-flat shadow" style="border: none">
        <div class="panel-body">
          <div class="form-group form-group-material">
            <label class="control-label" [ngClass]="getClasses(subjt.value)"><strong translate>Subject</strong></label>
            <input class="form-control" type="text" [(ngModel)]="subject" [placeholder]="translate.instant('Subject')" name="subjt" #subjt="ngModel">
          </div>
          <div class="form-group form-group-material">
            <label class="control-label" [ngClass]="getClasses(messj.value)"><strong translate>Message</strong></label>
            <textarea class="form-control bottom-border" [(ngModel)]="message" [placeholder]="translate.instant('Message')" name="messj" #messj="ngModel" rows="6" cols="50"> </textarea>
          </div>
        </div>
      </div>
   </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" type="button" (click)="hideModal()" translate>Cancel</button>
    <button class="btn btn-primary" type="button" (click)="FinishRecipientSettings()" translate>Done</button>
  </div>
 </div>
</div>
</div>


<!-- modal-add-edit-recipient -->
<div id="myModal" class="modal fade" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h6 class="modal-title">{{translate.instant(modalTitle)}}</h6>
      </div>
      <!--<form>-->
      <form #f="ngForm" novalidate>
        <!--(ngSubmit)="save(f.value, f.valid)"-->
        <div class="modal-body">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group form-group-material">
                <label for="name" class="control-label is-visible"><strong translate>Name</strong></label>
                <input type="text" id="name" name="name" class="form-control" [placeholder]="translate.instant('Name')" [(ngModel)]="theRecipient.name" #name="ngModel" required minlength="2" pattern="^[a-zA-ZsçÇöÖşŞıİğĞüÜ0-9]+(([',. -][a-zA-ZsçÇöÖşŞıİğĞüÜ0-9 ])?[a-zA-ZsçÇöÖşŞıİğĞüÜ0-9]*)*$">
                <!--show error only when field is not valid & it's dirty or form submited-->
                <small [hidden]="name.valid || (name.pristine && !f.submitted)" class="text-danger" translate>Name is required.</small>
              </div>
              <div class="form-group form-group-material">
                <label for="email" class="control-label is-visible"><strong translate>Email</strong></label>
                <input type="text" id="email" name="email" class="form-control" [disabled]="isDisabled" placeholder="john@doe.com" [(ngModel)]="theRecipient.email" #email="ngModel" required minlength="5" pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$" (input)="theRecipient.email = theRecipient.email?.toLowerCase()">
                <!--show error only when field is not valid & it's dirty or form submited-->
                <small [hidden]="email.valid || (email.pristine && !f.submitted)" class="text-danger" [innerHTML]="'EMAIL_REQUIRED_JOBDETAILS' | translate"></small>
              </div>
              <!-- İmza Yöntemi (signing method) -->
              <div class="form-group form-group-material">
                <label class="control-label is-visible"><strong>{{translate.instant('SIGN_METHOD_TITLE')}}</strong></label>
                <app-segmented-control
                  name="signMethod"
                  [options]="signMethodSegments"
                  [(ngModel)]="theRecipient.signMethod"
                  (changed)="onSignMethodChange($event)"
                  (stubSelected)="onSignMethodStub()">
                </app-segmented-control>
                <div class="sign-method-meta" *ngIf="activeMethodMeta">
                  <span class="sign-method-desc">{{translate.instant(activeMethodMeta.descriptionKey)}}</span>
                  <app-chip *ngIf="activeMethodMeta.identityChipKey"
                    [label]="translate.instant('SIGN_METHOD_AUTH_CHIP')"
                    [value]="translate.instant(activeMethodMeta.identityChipKey)">
                  </app-chip>
                </div>
              </div>

              <!-- Belgeye Erişim (document access) -->
              <div class="form-group form-group-material">
                <label class="control-label is-visible"><strong>{{translate.instant('ACCESS_GROUP_TITLE')}}</strong></label>
                <p class="group-caption">{{translate.instant('ACCESS_GROUP_CAPTION')}}</p>
                <app-toggle-row
                  [title]="translate.instant('ACCESS_EMAIL_TITLE')"
                  [subtitle]="translate.instant('ACCESS_EMAIL_SUBTITLE')"
                  icon="ph-bold ph-envelope-simple"
                  accent="#3a9bf4"
                  [mandatory]="true">
                </app-toggle-row>
                <app-toggle-row
                  [title]="translate.instant('ACCESS_PASSWORD_TITLE')"
                  [subtitle]="translate.instant('ACCESS_PASSWORD_SUBTITLE')"
                  icon="ph-bold ph-lock-key"
                  accent="#64748b"
                  [committable]="false"
                  (stubToggled)="onSignMethodStub()">
                </app-toggle-row>
                <app-toggle-row
                  [title]="translate.instant('ACCESS_OTP_TITLE')"
                  [subtitle]="translate.instant('ACCESS_OTP_SUBTITLE')"
                  icon="ph-bold ph-shield-check"
                  accent="#64748b"
                  [committable]="false"
                  (stubToggled)="onSignMethodStub()">
                </app-toggle-row>
              </div>

              <!-- Kimlik Doğrulama (identity authentication) — qes / bio only -->
              <div class="form-group form-group-material" *ngIf="activeMethodMeta?.identity">
                <label class="control-label is-visible"><strong>{{translate.instant('IDENTITY_GROUP_TITLE')}}</strong></label>
                <app-toggle-row *ngIf="activeMethodMeta?.identity === 'tck'"
                  [(ngModel)]="tckEnabled"
                  name="tckToggle"
                  [title]="translate.instant('IDENTITY_TCK_TITLE')"
                  [subtitle]="translate.instant('IDENTITY_TCK_SUBTITLE')"
                  icon="ph-bold ph-identification-card"
                  accent="#2f8def"
                  (changed)="onTckToggle($event)">
                  <input type="text" id="citizenId" name="citizenId" class="form-control"
                    [placeholder]="translate.instant('Citizen ID')"
                    [(ngModel)]="theRecipient.citizenId" #citizenId="ngModel"
                    inputmode="numeric" minlength="11" maxlength="11" pattern="[0-9]+"
                    [required]="tckEnabled" autocomplete="off">
                  <small [hidden]="citizenId.valid || (citizenId.pristine && !f.submitted)" class="text-danger">{{translate.instant("Citizen ID (11 numeric characters).")}}</small>
                </app-toggle-row>
                <app-toggle-row *ngIf="activeMethodMeta?.identity === 'sms'"
                  [(ngModel)]="smsEnabled"
                  name="smsToggle"
                  [title]="translate.instant('IDENTITY_SMS_TITLE')"
                  [subtitle]="translate.instant('IDENTITY_SMS_SUBTITLE')"
                  icon="ph-bold ph-device-mobile"
                  accent="#12a884"
                  (changed)="onSmsToggle($event)">
                  <div class="row">
                    <div class="col-md-4" style="padding-right: 0px;">
                      <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle" style="width: 100%;" type="button" data-toggle="dropdown"><img src="../../assets/images/country_flags/{{currentCountryFlag.fileName}}" class="country-flag"> {{currentCountryFlag.isoCode}} +{{currentCountryFlag.countryCode}}<span class="caret"></span></button>
                        <ul class="dropdown-menu scrollable-menu" style="min-width: 100%;">
                          <ng-container *ngFor="let listItem of countryFlags">
                            <li class="clickable country-code-list-item" (click)="pickCountry(listItem)" [title]="translate.instant(listItem.countryName)">
                              <img src="../../assets/images/country_flags/{{listItem.fileName}}" class="country-flag">{{translate.instant(listItem.countryName)}} - <b>(+{{listItem.countryCode}})</b>
                            </li>
                          </ng-container>
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-8" style="padding-left: 0px;">
                      <input type="text" id="smsRequired" name="smsRequired" class="form-control" placeholder="{{translate.instant('Phone Number')}}" [(ngModel)]="theRecipient.smsRequired" #smsRequired="ngModel" maxlength="{{calculatePhoneNumberLength(currentCountryFlag)}}" pattern="[0-9]+" [required]="smsEnabled" autocomplete="off">
                    </div>
                  </div>
                  <small [hidden]="smsRequired.valid || (smsRequired.pristine && !f.submitted)" class="text-danger" translate [translateParams]='{phoneLength:currentCountryFlag.phoneLength}'>PHONE_NUMBER_ERROR_JOBDETAILS</small>
                </app-toggle-row>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 text-right">
              <button *ngIf="modalTitle.includes('Add')" type="button" class="btn btn-default btn-size" (click)="addRecipient(f.value); f.reset()" [disabled]="!f.valid">{{translate.instant(modalAction)}}</button>
              <button *ngIf="modalTitle.includes('Update')" type="button" class="btn btn-default btn-size" (click)="updateRecipient(theRecipient); f.reset()" [disabled]="!f.valid">{{translate.instant(modalAction)}}</button>
              <button type="button" class="btn btn-link pull-right" data-dismiss="modal" translate>Cancel</button>
            </div>
          </div>
        </div>
      </form>
      <!--</form>-->
    </div>
  </div>
</div>

<!-- modal-address-book -->
<div id="addressBookModal" class="modal fade" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button type="button" class="close" data-dismiss="modal" (click)="this.checkedAddressBookItems = []" >&times;</button>
        <h6 class="modal-title">{{translate.instant(modalTitle)}}</h6>
      </div>
      <!--<form>-->
      <form>
        <!--(ngSubmit)="save(f.value, f.valid)"-->
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <input type="text" class="form-control" [(ngModel)]="nameSearchTerm" [placeholder]="translate.instant('Search by name...')" name="nameSearch" #nameSearch="ngModel">
            </div>
            <div class="col-md-6">
              <select class="form-control" [(ngModel)]="signTimeRangeFilter" name="signTimeFilter">
                <option *ngFor="let opt of signTimeFilterOptions" [value]="opt.value">{{translate.instant(opt.label)}}</option>
              </select>
            </div>
          </div>
          <br>
          <div class="row">
            <table class="table table-sm table-xm table-striped table-bordered">
              <thead>
                <tr>
                  <th></th>
                  <th (click)="nameFilterClicked()" >{{translate.instant("Name")}}<i class="pull-right" [ngClass]="{'icon-arrow-down5':nameFilterMultiplier == 1, 'icon-arrow-up5':nameFilterMultiplier == -1}"></i></th>
                  <th (click)="emailFilterClicked()">{{translate.instant("Email")}}<i class="pull-right" [ngClass]="{'icon-arrow-down5':emailFilterMultipler == 1, 'icon-arrow-up5':emailFilterMultipler == -1}"></i></th>
                  <th>{{translate.instant("Identity Number")}}</th>
                </tr>
              </thead>
              <tbody>

                <tr *ngFor="let addressBookItem of filteredAddressBook; let i = index">
                  <td><input type="checkbox" [id]="addressBookItem.id" (change)="onAddressBookCheckboxChange(addressBookItem);" [disabled]="addressBookItem.isActive"></td>
                  <td>{{addressBookItem.recipientName}}</td>
                  <td>{{addressBookItem.recipientEmail}}</td>
                  <td>{{addressBookItem.recipientIdentity}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <br><br>
          <hr>
          <div class="row">
            <div class="col-md-11 col-sm-11 col-xs-11 text-right">
              <button type="button" class="btn btn-default" (click)="addRecipientFromAddressBook()" [disabled]="this.checkedAddressBookItems.length <= 0">{{translate.instant('Add')}}</button>
              <button type="button" class="btn btn-link pull-right" data-dismiss="modal" (click)="this.checkedAddressBookItems = []" translate>Cancel</button>
            </div>
          </div>
        </div>
      </form>
      <!--</form>-->
    </div>
  </div>
</div>
<!-- /modal -->
